import { call, put } from 'redux-saga/effects';

import generateQuery from 'utils/generateQuery';

import {
  axiosAuthInstance,
  API_END_POINTS,
} from 'api';
import { MESSAGES } from 'appconstants';

import {
  OCR_REQUEST,
  LOADING,
  NOTIFICATION,
} from '../actionTypes';

const fetchOcrRequest = async (payload) => {
  const query = generateQuery(payload.currentPage);
  const sorting = payload.sortParams ? payload.sortParams : '&sortBy=createdAt&direction=DESC';
  if (payload.filterParams && !payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.GET_OCR_REQUEST}?${payload.filterParams}`);
  }
  if (payload.filterParams && payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.GET_OCR_REQUEST}${query}${sorting}&${payload.filterParams}`);
  }
  if (!payload.filterParams && payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.GET_OCR_REQUEST}${query}${sorting}`);
  }
  return axiosAuthInstance.get(`${API_END_POINTS.GET_OCR_REQUEST}${query}${sorting}`);
};

const postOcrRequest = async (params) => axiosAuthInstance.post(API_END_POINTS.GET_OCR_REQUEST, params);

export function* getOcrRequest(action) {
  try {
    const { data: { entity } } = yield call(fetchOcrRequest, action.payload);
    yield put({ type: OCR_REQUEST.SUCCESS, payload: entity });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
    yield put({ type: OCR_REQUEST.FAILED, payload: e.response.data });
  }
}

export function* addOcrRequest(action) {
  try {
    yield put({ type: LOADING.SUBMITTING });
    yield put({ type: LOADING.VALIDATING });
    yield call(postOcrRequest, action.payload);
    const { data: { entity } } = yield call(fetchOcrRequest, action.payload);
    yield put({ type: OCR_REQUEST.SUCCESS, payload: entity });
    yield put({
      type: NOTIFICATION.SUCCESS,
      payload: MESSAGES.OCRREQUEST.ADD_SUCCESS,
    });
    yield put({ type: LOADING.VALIDATED });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  } finally {
    yield put({ type: LOADING.SUBMITTED });
  }
}
